<template>
  <div>
    <div id="greatingText">
      <p id="greatText">¡El token ya no esta disponible!</p>
      <p id="explainGreat">
        Somos Globalwork. Una compañía que crea vínculos confiables en procesos <br> de selección a través de visitas domiciliarias y estudios de seguridad
      </p>
    </div>
    <div v-if="viewAlert" id="aboutUs" style="position: relative; top: 25vh; text-align: center;">
      <img id="serviceImg" src="https://www.globalwork.co/wp-content/uploads/2020/05/icon-verificacion-antecedentes-home.svg" alt="">
      <p id="firstInformativeText">
        ¿Quieres saber más acerca de nuestros Estudios de Seguridad?  
      </p>
      <a id="secodnInformativeText" href="https://www.globalwork.co/">
        Conoce más de nuestro servicio
      </a>  
    </div>    
  </div>
</template>

<script>
export default {
  name:'LaboralReferenceConfirmationTokenInvalid'
}
</script>
